function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "95gi40tmma",
  d: "M0.641 0.195L6.933 0.195 6.933 6.49 0.641 6.49z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H48V48H0z",
  transform: "translate(0 .75)"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 .75) translate(8 6.667) translate(21.333 .472)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "oe8wddym8b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#95gi40tmma"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#EFB726",
  d: "M6.933 3.341c0 1.738-1.407 3.149-3.145 3.149C2.052 6.49.64 5.08.64 3.34c0-1.738 1.41-3.146 3.147-3.146 1.738 0 3.145 1.408 3.145 3.146",
  mask: "url(#oe8wddym8b)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#1A1919",
  d: "M7.07 32.203l2.201-6.796c.008 0 .014.004.02.004h13.326l2.246 6.792H7.071zm8.803-27.176l2.994 9.051H12.94l2.932-9.051zm-3.663 11.31h7.405l2.25 6.803h-11.86l2.205-6.803zm18.403 15.866h-3.347L18.033 4.305c-.311-.929-1.181-1.554-2.162-1.554-.978.002-1.847.63-2.156 1.56L4.67 32.202H1.139c-.63 0-1.138.51-1.138 1.134 0 .628.508 1.134 1.138 1.134H30.613c.629 0 1.138-.506 1.138-1.134 0-.624-.51-1.134-1.138-1.134z",
  transform: "translate(0 .75) translate(8 6.667)"
})));

var SvgIconNetwork = function SvgIconNetwork(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconNetwork, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_network.4582ebb9.svg";
export { ForwardRef as ReactComponent };